import InputMask from "react-input-mask";
import React, { FC, memo } from "react";
import clsx from "clsx";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import s from "./Input.less";
import Button from "~/shared/ui/Fields/Button";

export type TAling = "center" | "right" | "left";

interface IProps {
  label?: string;
  labelAlign?: TAling;
  name: string;
  error?: string;
  type?: string;
  id?: string;
  maxLength?: number;
  control;
  disabled?: boolean;
  search?: boolean;
  defaultChecked?: boolean;
  rusValidation?: boolean;
  multiple?: boolean;
  orange?: boolean;
  onKeyDown?;
  defaultValue?: string | number;
  step?: number;
  placeholder?: string;
  customClassName?: string;
  values?: string | {};
  rules?: object;
  mask?;
  min?;
  max?;
  onBlurCapture?;
  onBlur?;
  subLabel?;
  noSpace?;
  isEmail?;
  isMultiplyEmail?;
  onChangeDecorator?;
  withButton?: boolean;
  newStyle?: boolean;
  setValues?;
  getValues?;
}

export const Input: FC<IProps> = ({
  label,
  labelAlign = "center",
  name,
  error,
  maxLength,
  type = "text",
  id = "",
  values = "",
  step = 1,
  rules = {},
  control,
  onKeyDown,
  mask,
  defaultValue,
  placeholder,
  disabled = false,
  multiple = false,
  rusValidation = false,
  defaultChecked = false,
  search = false,
  newStyle = false,
  orange = false,
  customClassName = "",
  onBlurCapture = () => {},
  onBlur = () => {},
  min,
  max,
  subLabel,
  noSpace,
  isEmail,
  isMultiplyEmail,
  onChangeDecorator = (val: any) => val,
  withButton,
  setValues,
  getValues,
}) => {
  const { t } = useTranslation();
  const align = { textAlign: labelAlign };
  const setMin = () => {
    if (typeof min === "number") {
      return {
        min,
      };
    }
  };
  const setMax = () => {
    if (typeof max === "number") {
      return {
        max,
      };
    }
  };

  const handleButtonClick = () => {
    const inputValue = getValues(name);
    setValues(inputValue);
  };

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={defaultValue}
      render={({ value, onChange, ...props }) => {
        return (
          <div
            className={clsx({
              [s.s_input]: true,
              [s.search]: search,
              [s.s_orange]: orange,
              [s.newStyle]: newStyle,
              [s.s_radio]: type === "radio",
              [s.s_hidden]: type === "hidden",
              [s.error]: error,
              [customClassName]: true,
            })}
          >
            {label && type !== "radio" && (
              <label style={align}>
                {label}
                {subLabel && <p className={s.subLabel}>{subLabel}</p>}
                {withButton && (
                  <Button
                    txtBtn={"="}
                    onClick={handleButtonClick}
                    orange
                    small
                    customClassName={s.btnActive}
                  />
                )}
              </label>
            )}
            <div
              className={clsx(s.desc, {
                [s.type_radio]: type === "radio",
                [s.disabled]: disabled,
              })}
            >
              {mask ? (
                <InputMask
                  {...props}
                  type={type}
                  mask={mask}
                  name={name}
                  id={id}
                  maxLength={maxLength}
                  disabled={disabled}
                  onChange={onChange}
                  defaultChecked={defaultChecked}
                  placeholder={placeholder}
                  value={values ? values : value || ""}
                />
              ) : (
                <input
                  {...{ ...props, ...setMin(), ...setMax() }}
                  type={type}
                  name={name}
                  id={id}
                  maxLength={maxLength}
                  disabled={disabled}
                  step={step}
                  onKeyDown={onKeyDown}
                  onChange={(changeEvent) => {
                    let event = changeEvent;
                    if (noSpace) {
                      event = {
                        ...event,
                        target: {
                          ...event.target,
                          value: event.target.value.replace(/ /gi, ""),
                        },
                      } as React.ChangeEvent<HTMLInputElement>;
                    }
                    if (isEmail) {
                      event = {
                        ...event,
                        target: {
                          ...event.target,
                          value: event.target.value.replace(
                            /[№"!#\$%\^\&*\/\[\]|}{)\\(+=,±;'?:<>а-яА-Я’»]/g,
                            ""
                          ),
                        },
                      } as React.ChangeEvent<HTMLInputElement>;
                    }
                    if (isMultiplyEmail) {
                      event = {
                        ...event,
                        target: {
                          ...event.target,
                          value: event.target.value.replace(
                            /[№"!#\$%\^\&*\/\[\]|}{)\\(+=±'?:<>а-яА-Я’»]/g,
                            ""
                          ),
                        },
                      } as React.ChangeEvent<HTMLInputElement>;
                    }
                    onChangeDecorator
                      ? onChange(onChangeDecorator(event))
                      : onChange(event);
                  }}
                  defaultChecked={defaultChecked}
                  placeholder={placeholder}
                  multiple={multiple}
                  value={values ? values : !value ? "" : value}
                  onBlurCapture={onBlurCapture}
                  onBlur={onBlur}
                />
              )}

              {label && type === "radio" && (
                <label
                  className={clsx({
                    [s.radio]: type === "radio",
                  })}
                  htmlFor={id}
                >
                  {label}
                </label>
              )}
              {error && <span className={s.error_text}>{error}</span>}
            </div>
          </div>
        );
      }}
    />
  );
};

export default memo(Input);
